import sanityClient from '@sanity/client';
import imageUrlBuilder from '@sanity/image-url';

export const client = sanityClient({
  projectId: '5xxa1k9g',
  dataset: 'production',
  apiVersion: '2022-02-01',
  useCdn: true,
  token:
    'skXuQapi6d4SIGjsfbsiZ6fw7JpEwGhc9KvWkMPYiwKmWIKDG8CeObybiO3OMKZQfXvLuN2RVSOulp1MOtbR8O8CFpVgQ09kXoN33zsDMzQoiyUQLpXNrYNbt4awa6HV25F9RH35CNgD3RK0vtZjCFINbqRWMRjsqG7EaiVgMTjlYw0qdcaT',
});

const builder = imageUrlBuilder(client);

export const urlFor = (source) => builder.image(source);
